"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (virtual) { return function () {
    var device = virtual.device;
    return {
        action: 'requestVerify',
        msgId: virtual.msgId,
        params: {
            devTid: device.devTid,
            prodKey: device.prodKey
        }
    };
}; });



// WEBPACK FOOTER //
// ./src/actions/send/actions/requestVerify.ts